exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".text-green[data-v-750c0724]{color:#0e9604}.link--small[data-v-750c0724]{color:#cf004a;cursor:pointer;font-size:12px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-750c0724","scoped":true,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/activation-codes/activation-codes.vue
// module id = 891
// module chunks = 0